import apiClient from "./axios";

const BASE_PATH = "/v3/external-crawl/admin";

const externalCrawlAdminApi = {
    getConfigs: () => apiClient.get(`${BASE_PATH}/configs`),
    createConfig: (data) => apiClient.post(`${BASE_PATH}/configs`, data),
    updateConfig: (id, data) => apiClient.put(`${BASE_PATH}/configs/${id}`, data),
    setConfigEnabled: (id, enabled) => apiClient.patch(`${BASE_PATH}/configs/${id}/enabled`, { enabled }),
    deleteConfig: (id) => apiClient.delete(`${BASE_PATH}/configs/${id}`),

    getCredentials: (configId) => apiClient.get(`${BASE_PATH}/configs/${configId}/credentials`),
    createCredential: (configId, data) => apiClient.post(`${BASE_PATH}/configs/${configId}/credentials`, data),
    updateCredential: (id, data) => apiClient.put(`${BASE_PATH}/credentials/${id}`, data),
    setCredentialEnabled: (id, enabled) => apiClient.patch(`${BASE_PATH}/credentials/${id}/enabled`, { enabled }),
    deleteCredential: (id) => apiClient.delete(`${BASE_PATH}/credentials/${id}`),

    getPermissions: (configId) => apiClient.get(`${BASE_PATH}/configs/${configId}/permissions`),
    replacePermissions: (configId, items) => apiClient.put(`${BASE_PATH}/configs/${configId}/permissions`, { items }),
    getUserOptions: (params = {}) => apiClient.get(`${BASE_PATH}/users`, { params }),

    getTasks: (params = {}) => apiClient.get(`${BASE_PATH}/tasks`, { params }),
    getFiles: (params = {}) => apiClient.get(`${BASE_PATH}/files`, { params }),
    getFilePreviewUrl: (fileId, params = {}) => apiClient.get(`${BASE_PATH}/files/${fileId}/preview-url`, { params }),
    batchDownloadFiles: (fileIds) => apiClient.post(`${BASE_PATH}/files/batch-download`, { file_ids: fileIds }),
    getDateSnapshots: (params = {}) => apiClient.get(`${BASE_PATH}/date-snapshots`, { params }),
};

export default externalCrawlAdminApi;
